import { EventEmitter, Injectable, Input, Output } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export type InputLabelStateValue =
  | "enabled"
  | "read-only"
  | "disabled"
  | "invalid"
  | "valid"
  | "info"
  | "warning";

export const InputLabelStateMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class InputLabelState extends Clazz {
    @Input()
    public inputLabelState: InputLabelStateValue;

    @Output() inputLabelStateChange = new EventEmitter<InputLabelStateValue>();
  }

  return InputLabelState;
};

export const InputLabelStateMixinInputs = ["inputLabelState"];
